module.exports = __webpack_public_path__ + "static/media/dashboard-card.8692a107.png";